import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".profile-picture-empty_svg__a{fill:none;stroke:#fafafb;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px}"));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-4 -2.5)"
}, /*#__PURE__*/React.createElement("circle", {
  className: "profile-picture-empty_svg__a",
  cx: 8.076,
  cy: 8.076,
  r: 8.076,
  transform: "translate(10.226 3.5)"
}), /*#__PURE__*/React.createElement("path", {
  className: "profile-picture-empty_svg__a",
  d: "M5 35.803a13.3 13.3 0 1126.6 0z"
}));

function SvgProfilePictureEmpty(props) {
  return /*#__PURE__*/React.createElement("svg", props, _ref, _ref2);
}

export default "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg'%3E%3Cdefs%3E%3Cstyle%3E.a%7Bfill:none;stroke:%23fafafb;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px%7D%3C/style%3E%3C/defs%3E%3Cg transform='translate(-4 -2.5)'%3E%3Ccircle class='a' cx='8.076' cy='8.076' r='8.076' transform='translate(10.226 3.5)'/%3E%3Cpath class='a' d='M5 35.803a13.3 13.3 0 1126.6 0z'/%3E%3C/g%3E%3C/svg%3E";
export { SvgProfilePictureEmpty as ReactComponent };